import isServer from './KServer'
import $ from 'jquery'

class QueryBase {
  on() {
    return this
  }

  off() {
    return this
  }

  one() {
    return this
  }

  trigger() {
    return this
  }

  remove() {
    return this
  }

  data() {
    return this
  }

  appendTo() {
    return this
  }

  attr() {
    return this
  }

  cropper() {
    return this
  }

  height() {
  }

  width() {
  }

  outerHeight() {
  }

  outerWidth() {
  }

  scrollTop() {
  }

  addClass() {
    return this
  }

  removeClass() {
    return this
  }

  hasClass() {
    return false
  }

  text() {
    return ''
  }
}

function SQuery() {
  return new QueryBase()
}

const CQuery = isServer ? SQuery : $

export default CQuery
